import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectAddIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.6001 20.8496H9.1001C8.686 20.8496 8.3501 21.1855 8.3501 21.5996C8.3501 22.0137 8.686 22.3496 9.1001 22.3496H9.6001C10.0142 22.3496 10.3501 22.0137 10.3501 21.5996C10.3501 21.1855 10.0142 20.8496 9.6001 20.8496Z"
        fill={color}
      />
      <path
        d="M6.62008 20.8496H5.37988C4.96578 20.8496 4.62988 21.1855 4.62988 21.5996C4.62988 22.0137 4.96578 22.3496 5.37988 22.3496H6.62008C7.03418 22.3496 7.37008 22.0137 7.37008 21.5996C7.37008 21.1855 7.03418 20.8496 6.62008 20.8496Z"
        fill={color}
      />
      <path
        d="M3.1177 20.8818C3.0244 20.5742 2.7383 20.3496 2.3999 20.3496C1.9858 20.3496 1.6499 20.6855 1.6499 21.0996V21.5996C1.6499 22.0137 1.9858 22.3496 2.3999 22.3496H2.8999C3.314 22.3496 3.6499 22.0137 3.6499 21.5996C3.6499 21.2607 3.4258 20.9746 3.1177 20.8818Z"
        fill={color}
      />
      <path
        d="M2.3999 16.4971C2.814 16.4971 3.1499 16.1612 3.1499 15.7471V14.6758C3.1499 14.2617 2.814 13.9258 2.3999 13.9258C1.9858 13.9258 1.6499 14.2617 1.6499 14.6758V15.7471C1.6499 16.1612 1.9858 16.4971 2.3999 16.4971Z"
        fill={color}
      />
      <path
        d="M2.3999 10.0728C2.814 10.0728 3.1499 9.73685 3.1499 9.32275V8.25195C3.1499 7.83785 2.814 7.50195 2.3999 7.50195C1.9858 7.50195 1.6499 7.83785 1.6499 8.25195V9.32275C1.6499 9.73685 1.9858 10.0728 2.3999 10.0728Z"
        fill={color}
      />
      <path
        d="M2.3999 6.86084C2.814 6.86084 3.1499 6.52494 3.1499 6.11084V5.04004C3.1499 4.62594 2.814 4.29004 2.3999 4.29004C1.9858 4.29004 1.6499 4.62594 1.6499 5.04004V6.11084C1.6499 6.52494 1.9858 6.86084 2.3999 6.86084Z"
        fill={color}
      />
      <path
        d="M2.3999 19.709C2.814 19.709 3.1499 19.3731 3.1499 18.959V17.8877C3.1499 17.4736 2.814 17.1377 2.3999 17.1377C1.9858 17.1377 1.6499 17.4736 1.6499 17.8877V18.959C1.6499 19.3731 1.9858 19.709 2.3999 19.709Z"
        fill={color}
      />
      <path
        d="M2.3999 13.2852C2.814 13.2852 3.1499 12.9493 3.1499 12.5352V11.4639C3.1499 11.0498 2.814 10.7139 2.3999 10.7139C1.9858 10.7139 1.6499 11.0498 1.6499 11.4639V12.5352C1.6499 12.9493 1.9858 13.2852 2.3999 13.2852Z"
        fill={color}
      />
      <path
        d="M2.8999 1.6499H2.3999C1.9858 1.6499 1.6499 1.9858 1.6499 2.3999V2.8999C1.6499 3.314 1.9858 3.6499 2.3999 3.6499C2.7383 3.6499 3.0244 3.4258 3.1177 3.1177C3.4258 3.0244 3.6499 2.7383 3.6499 2.3999C3.6499 1.9858 3.314 1.6499 2.8999 1.6499Z"
        fill={color}
      />
      <path
        d="M14.6768 3.1499H15.7481C16.1622 3.1499 16.4981 2.814 16.4981 2.3999C16.4981 1.9858 16.1622 1.6499 15.7481 1.6499H14.6768C14.2627 1.6499 13.9268 1.9858 13.9268 2.3999C13.9268 2.814 14.2627 3.1499 14.6768 3.1499Z"
        fill={color}
      />
      <path
        d="M17.8887 3.1499H18.96C19.3741 3.1499 19.71 2.814 19.71 2.3999C19.71 1.9858 19.3741 1.6499 18.96 1.6499H17.8887C17.4746 1.6499 17.1387 1.9858 17.1387 2.3999C17.1387 2.814 17.4746 3.1499 17.8887 3.1499Z"
        fill={color}
      />
      <path
        d="M10.0742 2.3999C10.0742 1.9858 9.73833 1.6499 9.32423 1.6499H8.25293C7.83883 1.6499 7.50293 1.9858 7.50293 2.3999C7.50293 2.814 7.83883 3.1499 8.25293 3.1499H9.32423C9.73833 3.1499 10.0742 2.814 10.0742 2.3999Z"
        fill={color}
      />
      <path
        d="M6.11182 3.1499C6.52592 3.1499 6.86182 2.814 6.86182 2.3999C6.86182 1.9858 6.52592 1.6499 6.11182 1.6499H5.04102C4.62692 1.6499 4.29102 1.9858 4.29102 2.3999C4.29102 2.814 4.62692 3.1499 5.04102 3.1499H6.11182Z"
        fill={color}
      />
      <path
        d="M12.5361 3.1499C12.9502 3.1499 13.2861 2.814 13.2861 2.3999C13.2861 1.9858 12.9502 1.6499 12.5361 1.6499H11.4648C11.0507 1.6499 10.7148 1.9858 10.7148 2.3999C10.7148 2.814 11.0507 3.1499 11.4648 3.1499H12.5361Z"
        fill={color}
      />
      <path
        d="M21.5996 1.6499H21.0996C20.6855 1.6499 20.3496 1.9858 20.3496 2.3999C20.3496 2.7383 20.5742 3.0244 20.8818 3.1177C20.9746 3.4258 21.2607 3.6499 21.5996 3.6499C22.0137 3.6499 22.3496 3.314 22.3496 2.8999V2.3999C22.3496 1.9858 22.0137 1.6499 21.5996 1.6499Z"
        fill={color}
      />
      <path
        d="M21.5996 4.62988C21.1855 4.62988 20.8496 4.96578 20.8496 5.37988V6.62008C20.8496 7.03418 21.1855 7.37008 21.5996 7.37008C22.0137 7.37008 22.3496 7.03418 22.3496 6.62008V5.37988C22.3496 4.96578 22.0137 4.62988 21.5996 4.62988Z"
        fill={color}
      />
      <path
        d="M21.5996 8.3501C21.1855 8.3501 20.8496 8.686 20.8496 9.1001V9.6001C20.8496 10.0142 21.1855 10.3501 21.5996 10.3501C22.0137 10.3501 22.3496 10.0142 22.3496 9.6001V9.1001C22.3496 8.686 22.0137 8.3501 21.5996 8.3501Z"
        fill={color}
      />
      <path
        d="M21.5996 16.0498H17.5498V12C17.5498 11.5859 17.2139 11.25 16.7998 11.25C16.3857 11.25 16.0498 11.5859 16.0498 12V16.0498H12C11.5859 16.0498 11.25 16.3857 11.25 16.7998C11.25 17.2139 11.5859 17.5498 12 17.5498H16.0498V21.5996C16.0498 22.0137 16.3857 22.3496 16.7998 22.3496C17.2139 22.3496 17.5498 22.0137 17.5498 21.5996V17.5498H21.5996C22.0137 17.5498 22.3496 17.2139 22.3496 16.7998C22.3496 16.3857 22.0137 16.0498 21.5996 16.0498Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectAddIcon.displayName = 'SelectAddIcon';
